// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file legebill/type/tag_category.proto (package legebill.type, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file legebill/type/tag_category.proto.
 */
export const file_legebill_type_tag_category: GenFile = /*@__PURE__*/
  fileDesc("CiBsZWdlYmlsbC90eXBlL3RhZ19jYXRlZ29yeS5wcm90bxINbGVnZWJpbGwudHlwZSJ1CgtUYWdDYXRlZ29yeRIKCgJpZBgBIAEoCRIPCgdzaXRlX2lkGAIgASgJEhMKC2V4dGVybmFsX2lkGAMgASgJEg0KBWxhYmVsGAQgASgJEhMKC2Rlc2NyaXB0aW9uGAUgASgJEhAKCGtleXdvcmRzGAYgAygJQisKFWNvbS5sZWdlYmlsbC5hcGkudHlwZUIQVGFnQ2F0ZWdvcnlQcm90b1ABYgZwcm90bzM");

/**
 * Resource sites/*\/tag-categories/*
 *
 * A tag category groups related tags together. Tag categories can be automatically
 * applied to time rows and time groups by auto-tagging. However, tag categories
 * cannot be posted. The purpose of tag categories is to give the user as much help
 * as possible with auto-tagging if we are unable to match a specific tag but are
 * able to match on a group of tags. The user then just needs to select one of the
 * tags in the category, rather than having to start with a fresh tag search.
 *
 * @generated from message legebill.type.TagCategory
 */
export type TagCategory = Message<"legebill.type.TagCategory"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * Optional. Usually set if this tag category was synced via a connector.
   *
   * @generated from field: string external_id = 3;
   */
  externalId: string;

  /**
   * The label may not be unique.
   *
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * Optional description for the category.
   *
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * Used by tag matcher to automatically apply tag categories to time rows.
   *
   * @generated from field: repeated string keywords = 6;
   */
  keywords: string[];
};

/**
 * Describes the message legebill.type.TagCategory.
 * Use `create(TagCategorySchema)` to create a new message.
 */
export const TagCategorySchema: GenMessage<TagCategory> = /*@__PURE__*/
  messageDesc(file_legebill_type_tag_category, 0);

